<template>
  <div class="solutions">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">Our Specialized IT Solutions</h3>
        <p>RPA, System Integration, IT Consulting, IT Outsourcing</p>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <v-img :src="require('@/assets/img_sub_ser_solutions.svg')" contain max-height="462"></v-img>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'solutions',
  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".solutions .sub-body-title", {
      scrollTrigger: {
        trigger: ".solutions .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".solutions .sub-body-content", {
      scrollTrigger: {
        trigger: ".solutions .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>